module.exports = __webpack_public_path__ + "img/face-icicles.4b565798.svg";